import { Component, Input } from '@angular/core';
import { SpecialsItem } from '../../menu.model';

@Component({
  selector: 'drink-for-a-cause',
  templateUrl: './drink-for-a-cause.component.html',
  styleUrls: ['./drink-for-a-cause.component.scss']
})
export class DrinkForACauseComponent  {

  constructor() { }

  @Input() drinkForCause: Array<SpecialsItem> = [];
  @Input() activeSection: string | undefined;

}
